import { useIntl, FormattedMessage } from 'react-intl';

import { useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

import ContentView from '~/components/ContentView';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useCreateExperience } from '~/hooks/api/useCreateExperience';
import { usePublisherMe } from '~/hooks/api/usePublisherMe';
import CreateExperienceForm from './CreateExperienceForm';
import messages from './messages';
import { useNavigate } from '@tanstack/react-router';

export const CreateExperience = () => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const theme = useTheme();
  const navigate = useNavigate();
  const { data: publisherData } = usePublisherMe();

  const gotoExperienceOverview = () => {
    navigate({ to: '/experiences' });
  };

  const createExperienceMutation = useCreateExperience({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.createExperienceSuccess),
      });
      gotoExperienceOverview();
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.createExperienceFailure),
      });
    },
  });

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <IconButton
              id="back-button"
              onClick={gotoExperienceOverview}
              color="inherit"
              size="large"
              aria-label={intl.formatMessage(messages.back)}
            >
              <CloseIcon />
            </IconButton>
            <Typography
              variant="h6"
              style={{ marginLeft: theme.spacing(2) }}
              sx={{
                color: 'inherit',
              }}
            >
              <FormattedMessage {...messages.newHeader} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
    >
      {publisherData?.id && (
        <CreateExperienceForm
          onSubmit={createExperienceMutation.mutate}
          publisherId={publisherData.id}
        />
      )}
    </ContentView>
  );
};

export default CreateExperience;
